module.exports = __webpack_public_path__ + "static/img/成五-蔡坤益.47e969b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成五-蔡坤益.jpg
// module id = aHVJ
// module chunks = 1